import React from 'react'

import FormHandler from 'components/Form/FormHandler'
import InputDecorated from 'components/Form/InputDecorated'
import FormContext from 'components/Form/FormContext'
import FormContextProvider from 'components/Form/FormContextProvider'

const UserChangePassword = ({history}) => {
  const form = React.useContext(FormContext)

  const submitCallback = (values, setLoading) => {

    // TODO
    console.log(values, setLoading)
    setTimeout(() => {
      history.push('/home/profile')
    }, 1500)

  }

  const compareToFirstPassword = (rule, value, callback) => {
    if (value && value !== form.getFieldValue('password')) {
      callback('Passwords do not match')
    } else {
      callback()
    }
  }

  return (
    <FormHandler submitCallback={submitCallback} submitTitle={'Change password'}>
      <InputDecorated fieldName='passwordOld' placeholder='Old password' password
                      rules={[{required: true, message: 'Please provide your old password'}]}/>
      <InputDecorated fieldName='password' placeholder='New password' password
                      rules={[{required: true, message: 'Please input your new password'}]}/>
      <InputDecorated fieldName='passwordMatch' placeholder='Repeat your new password' password
                      rules={[
                        {required: true, message: 'Please repeat your new password'},
                        {validator: compareToFirstPassword},
                      ]}/>
    </FormHandler>
  )
}

export default ({history}) => <FormContextProvider><UserChangePassword history={history}/></FormContextProvider>
